/*
 * @Author: June
 * @Description:
 * @Date: 2023-10-29 12:18:14
 * @LastEditors: 秦少卫
 * @LastEditTime: 2024-09-12 10:17:45
 */
import { createI18n } from 'vue-i18n';
import { lang as kuaituLang } from '@kuaitu/core';
import { getParamFromURL } from '@/utils/index';
// iview
import iviewZhCN from 'view-ui-plus/dist/locale/zh-CN';
import iviewEnUS from 'view-ui-plus/dist/locale/en-US';
import iviewZhTW from 'view-ui-plus/dist/locale/zh-TW';
import iviewKoKR from 'view-ui-plus/dist/locale/ko-KR';
import iviewJoJP from 'view-ui-plus/dist/locale/ja-JP';
import iviewEsES from 'view-ui-plus/dist/locale/es-ES';

// locale
import zhCN from './zh-CN.json';
import enUS from './en-US.json';
import zhTW from './zh-TW.json';
import koKR from './ko-KR.json';
import jaJP from './ja-JP.json';
import esES from './es-ES.json';

// utils
import { getLocal, setLocal } from '@/utils/local';

// map
const messages = {
  'zh-CN': Object.assign(zhCN, iviewZhCN, kuaituLang['zh-CN']),
  'en-US': Object.assign(enUS, iviewEnUS, kuaituLang['en-US']),
  'zh-TW': Object.assign(zhTW, iviewZhTW, kuaituLang['zh-TW']),
  'ko-KR': Object.assign(koKR, iviewKoKR, kuaituLang['ko-KR']),
  'ja-JP': Object.assign(jaJP, iviewJoJP, kuaituLang['ja-JP']),
  'es-ES': Object.assign(esES, iviewEsES, kuaituLang['es-ES']),
};

export const LANGMAP = {
  'zh-CN': '中文',
  'en-US': 'En',
  'zh-TW': '繁体',
  'ko-KR': '한국어',
  'ja-JP': '日本語',
  'es-ES': 'Español',
} as {
  [key: string]: string;
};

export const langList = Object.keys(LANGMAP).map((key: string) => ({
  langType: key,
  langName: LANGMAP[key],
}));

export const LANG = 'lang';

function getLocalLang() {
  // 地址栏获取
  const urlLang = getParamFromURL('lang');
  if (urlLang && LANGMAP[urlLang]) {
    setLocal(LANG, urlLang);
    return urlLang;
  }
  // 本地存储获取
  const localLang = getLocal(LANG);
  if (!localLang) {
    const defaultLang = navigator.language;
    setLocal(LANG, defaultLang);
    return defaultLang;
  }
  // 适配其他情况
  if (LANGMAP[localLang]) {
    return localLang;
  }
  return 'zh-CN';
}
const lang = getLocalLang();

const i18n = createI18n({
  allowComposition: true,
  globalInjection: true,
  legacy: false,
  locale: lang,
  messages,
});

export default i18n;
export const t = (key: any) => {
  return i18n.global.t(key);
};
